<div class="modal_dialog address-details-modal">
  <div class="modal_header">
    <h2>{{ "DeliveryAddress" | translate }}</h2>
    <button class="btnn close_icon" type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal_body">
    <div class="cards-container">
    <!-- Contact Information Card -->
    <div class="info-card">
      <div class="card-header">
        <h3>{{ "ContactInformation" | translate }}</h3>
      </div>
      <div class="card-content">
        <div class="info-row">
          <div class="info-item">
            <span class="label">{{ "Name" | translate }}</span>
            <span class="value">{{ data.data.name }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ "Email" | translate }}</span>
            <span class="value">{{ data.data.email }}</span>
          </div>
        </div>
        <div class="info-row">
          <div class="info-item">
            <span class="label">{{ "Phone" | translate }}</span>
            <span class="value">{{ data.data.countryCode }} {{ data.data.phoneNo }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ "AddressType" | translate }}</span>
            <span class="value">{{ addressType[data.data.addressType] || "---" }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Location Information Card -->
    <div class="info-card">
      <div class="card-header">
        <h3>{{ "LocationInformation" | translate }}</h3>
      </div>
      <div class="card-content">
        <div class="info-row">
          <div class="info-item">
            <span class="label">{{ "City" | translate }}</span>
            <span class="value">{{ data.data.city || "---" }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ "State" | translate }}</span>
            <span class="value">{{ data.data.state || "---" }}</span>
          </div>
        </div>
        <div class="info-row">
          <div class="info-item">
            <span class="label">{{ "Country" | translate }}</span>
            <span class="value">{{ data.data.country || "---" }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ "Pincode" | translate }}</span>
            <span class="value">{{ data.data.pincode || "---" }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ "landMark" | translate }}</span>
            <span class="value">{{ data.data.landMark || "---" }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ "houseNo" | translate }}</span>
            <span class="value">{{ data.data.houseNo || "---" }}</span>
          </div>
        </div>
        <div class="info-row">
          <div class="info-item full-width">
            <span class="label">{{ "FullAddress" | translate }}</span>
            <span class="value">{{ data.data.address || "---" }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Coordinates Card -->
    <div class="info-card">
      <div class="card-header">
        <h3>{{ "Coordinates" | translate }}</h3>
      </div>
      <div class="card-content">
        <div class="info-row">
          <div class="info-item">
            <span class="label">{{ "Latitude" | translate }}</span>
            <span class="value">{{ data.data.latitude }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ "Longitude" | translate }}</span>
            <span class="value">{{ data.data.longitude }}</span>
          </div>
        </div>
        <div class="info-row">
          <div class="info-item full-width">
            <button mat-raised-button (click)="openGoogleMaps()" class="map-button primary-color">
              <mat-icon>map</mat-icon>
              {{ "ViewOnMap" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</div> 